import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

/**
 * Daily analytics snapshots for Recon metrics.
 */
@Entity('recon_analytics_daily')
@Index('idx_recon_analytics_date', ['ownerUserId', 'snapshotDate'], {
	unique: true,
})
export class ReconAnalyticsDailyEntity extends BaseEntity {
	// Date
	@Column('date', { name: 'snapshot_date' })
	public snapshotDate!: Date;

	// Signal metrics
	@Column('int', { name: 'signals_detected', default: 0 })
	public signalsDetected!: number;

	@Column('json', { name: 'signals_by_platform', nullable: true })
	public signalsByPlatform!: Record<string, number> | null;

	@Column('json', { name: 'signals_by_type', nullable: true })
	public signalsByType!: Record<string, number> | null;

	// Opportunity metrics
	@Column('int', { name: 'opportunities_created', default: 0 })
	public opportunitiesCreated!: number;

	@Column('int', { name: 'opportunities_approved', default: 0 })
	public opportunitiesApproved!: number;

	@Column('int', { name: 'opportunities_dismissed', default: 0 })
	public opportunitiesDismissed!: number;

	@Column('decimal', {
		name: 'avg_score',
		precision: 5,
		scale: 2,
		nullable: true,
	})
	public avgScore!: number | null;

	// Interaction metrics
	@Column('int', { name: 'interactions_drafted', default: 0 })
	public interactionsDrafted!: number;

	@Column('int', { name: 'interactions_approved', default: 0 })
	public interactionsApproved!: number;

	@Column('int', { name: 'interactions_sent', default: 0 })
	public interactionsSent!: number;

	@Column('int', { name: 'interactions_failed', default: 0 })
	public interactionsFailed!: number;

	// Conversation metrics
	@Column('int', { name: 'conversations_started', default: 0 })
	public conversationsStarted!: number;

	@Column('int', { name: 'replies_received', default: 0 })
	public repliesReceived!: number;

	@Column('int', { name: 'conversations_converted', default: 0 })
	public conversationsConverted!: number;

	// CRM metrics
	@Column('int', { name: 'leads_created', default: 0 })
	public leadsCreated!: number;

	@Column('int', { name: 'contacts_linked', default: 0 })
	public contactsLinked!: number;
}
